import { ShiftPersonGroup, RoleGroupName, TaskRole } from "../common/train";

/**Get role group name by personGroup and role
   * @param personGroup
   * @param role
   */
export function getRoleGroupName(personGroup: ShiftPersonGroup, role: TaskRole): RoleGroupName | string {
    const groupAndRole = `${personGroup}-${role}`;
    switch (groupAndRole) {
      case 'DRIVER-LEAD':
        return RoleGroupName.Driver;
      case 'DRIVER-ASSIST':
        return RoleGroupName.AssistDriver;
      case 'CONDUCTOR-LEAD':
        return RoleGroupName.Conductor;
      case 'CONDUCTOR-ASSIST':
        return RoleGroupName.AssistConductor;
      case 'DRIVER-PACKAGE':
        return RoleGroupName.Package;
      default:
        return groupAndRole;
    }
}